<template>
  <div style="text-align: center;">
    <img style="max-width:100%" src="@/assets/img/rdms.png" alt="rdms轮播图">
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {}
}
</script>
<style lang='scss' scoped>
</style>
